// notePopup.component.jsx
import { useEffect, useState, useRef } from "react";
import RichNoteEditor from "./noteEditor.component.jsx";
import RichNoteViewer from "./richNoteViewer.component.jsx";
import DragBox from "../../../Universals/DragBox/dragBox.component.jsx";
import { useBoxContext } from "../../../../Contexts/boxData.context.jsx";
import { usePlayer } from "../../../../Contexts/playerData.context.jsx";
import { decodeFBX } from "../../../../utils/functions.ts";

export default function NoteEditorPage() {
  const [html, setHtml] = useState("");
  const NOTES_ENDPOINT = "https://www.fbxchange.com/ReactPHP/notes.php";

  const { NoteBoxID, setNoteResetCode, setNoteBoxID } = useBoxContext();
  const { activePlayer } = usePlayer();
  const [theNote, setTheNote] = useState(null);
  const [editable, setEditable] = useState(false);


  const fetchNote = async () => {
    setEditable(false);
    try {
      const decoded = decodeFBX();
      if (!decoded) return;
      const [scout, team, security, displayName] = decoded.split(",");

      const response = await fetch(NOTES_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ scout, team, scriptName: "getSingleNote", noteID: NoteBoxID }),
      });

      if (response.ok) {
        const data = await response.json();
        const noteContent = data.note;
        setTheNote(noteContent || null);

        // Decide editability and extract initial HTML from Communication/html fields
        let initialHtml = "";
        const comm = noteContent?.Communication;
        if (displayName === noteContent?.ByName) setEditable(true);
        if (typeof comm === "string") initialHtml = comm;
        else if (comm && typeof comm.html === "string") initialHtml = comm.html;
        else if (typeof noteContent?.html === "string") initialHtml = noteContent.html;
        setHtml(initialHtml);
      } else {
        setTheNote(null);
      }
    } catch (err) {
      setTheNote(null);
      console.error("Error fetching note:", err);
    }
  };


  useEffect(() => {
    fetchNote();
  }, [NoteBoxID]);

  // Save now expects the WHOLE updated note object from the editor
  const letsSaveNote = async (updatedNote) => {
    const decoded = decodeFBX();
    if (!decoded) return;
    const [scout, team, security, displayName] = decoded.split(",");
    try {
      const response = await fetch(NOTES_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          scriptName: "saveNote",
          note: updatedNote, // send full note
        }),
      });

      if (response.ok) {
        const data = await response.json();
        const rand = Math.floor(Math.random() * (100000 - 1000 + 1)) + 1000;
        setNoteResetCode(rand);
        setTheNote(null);
        setNoteBoxID(null);
      } else {
        setTheNote(null);
      }
    } catch (err) {
      setTheNote(null);
      console.error("Error fetching note:", err);
    }
  };


  const closeNoSave = () => {
    setTheNote(null);
    setNoteBoxID(null);
  };

   const handleEditorChange = (nextHtml) => {
    setHtml(nextHtml);
  };

  // Positioning
  const windowWidth = window.innerWidth;
  const boxWidth = Math.min(2000, windowWidth - 1170);

  return (
    theNote !== null && (
      <DragBox
        storageKey="NOTE_BOX_POSITION"
        defaultPos={{ x: boxWidth, y: 340 }}
        title={( `${activePlayer?.last ?? ""}, ${activePlayer?.first ?? ""} ${activePlayer?.school ?? ""} ${activePlayer?.colPos ?? ""}` ).toUpperCase()}
        width={1160}
        onAdd={null}
        zIndex={2050}
        addNote="-"
      >
        {editable ? (
          <div className="container mt-0" style={{ maxHeight: "390px", overflowY: "auto" }}>
            {/* Editor will return WHOLE updated note via letsSaveNote(updatedNote) */}
            <RichNoteEditor
              value={html}
              onChange={handleEditorChange} 
              noteData={theNote}
              letsSaveNote={letsSaveNote}
            />
          </div>
        ) : (
          <div className="container py-3" style={{ maxHeight: "390px", overflowY: "auto" }}>
            <RichNoteViewer html={html} showToolbar noteData={theNote} onClose={closeNoSave} />
          </div>
        )}
      </DragBox>
    )
  );
}
